import {AlertCircle, X} from "react-feather";
import React, {useRef, useState} from "react";
import {MESSAGE_REPORT_MAX} from "../../services/constants/MaxLenght";

export const ModalResendRequestUpdate = ({id, onHandleToggle, handleResendAction}) => {

    const messageRef = useRef(null);
    const [requestMessage, setRequestMessage] = useState('');
    const [showModalMessage, setShowModalMessage] = useState(true);

    const handleResend = () => {
        handleResendAction(id, requestMessage);
        onHandleToggle();
    };

    const handleRequestMessageChange = (event) => {
        const report = event.target.value;
        setRequestMessage(report);

        if (report.length > MESSAGE_REPORT_MAX) {
            messageRef.current.classList.add('sl-input-destructive');
        } else {
            messageRef.current.classList.remove('sl-input-destructive');
        }
    }

    const handleCloseModalMessage = () => {
        setShowModalMessage(false);
    };

    return (
        <div className="">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    Resend the request for updating the profile?
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>

            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">

                    {showModalMessage && (
                        <div className={`sl-flex sl-justify-between sl-align-flex-start sl-gap-2 sl-mb-6 sl-p-4
                                        sl-border-1-point-5 sl-border-solid sl-border-radius-8 sl-border-primary-300 sl-font sl-bg-blue-light-25
                                        sl-text-md sl-font-normal sl-text-md sl-w-fill-available sl-py-1 sl-px-4`}>
                            <div>{<AlertCircle size={16} className="sl-text-blue-light-800"/>}</div>
                            <p className={"sl-text-blue-light-800 sl-text-blue-light-base sl-pl-1 sl-m-0"}>We have sent several reminders to the
                                vendor, but we have not received a response to your request. <br/>Please feel free to submit a new request.</p>
                            <div className="sl-cursor-pointer sl-btn-link-color" onClick={handleCloseModalMessage}>
                                <X className={"sl-max-h-4 sl-max-w-4"}/>
                            </div>
                        </div>
                    )}

                    <div className="sl-flex sl-flex-col sl-justify-start sl-w-fill-available sl-gap-1-point-5">
                        <label htmlFor="request-vendor-update-message">Message (optional)</label>
                        <textarea placeholder="" ref={messageRef} value={requestMessage}
                                  id="request-vendor-update-message"
                                  onChange={handleRequestMessageChange}
                                  className="sl-input sl-modal-textarea sl-border-1 sl-shadow-xs sl-rounded-lg sl-font sl-font-normal sl-text-md sl-text-gray-base"
                                  required/>
                    </div>
                </div>
            </div>

            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle}
                            className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg ">
                        Cancel
                    </button>
                    <button onClick={handleResend}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Submit request
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalResendRequestUpdate;
